import React from "react";

export default function OverlayMaskWhite() {
    return <div className="overlay-mask-white" data-testid="overlay" />;
}
